<div class="sidebar">
  <div class="sidebar-header">
<img
  class="profile-img"
  [src]="profilePhoto"
  alt="Profile Picture"
  (error)="profilePhoto = FALLBACK_AVATAR"
/>

    <p class="profile-name">{{ profileDetails?.name || 'Your Name' }}</p>
    <p>{{ designation }}</p>
  </div>

  <!-- Scrollable area -->
  <div class="sidebar-scroll">
    <ul class="sidebar-menu">
      <!-- Communities -->
      <li routerLinkActive="active" *ngIf="domainService.isCommunityDomain()">
        <a (click)="goToProfile()">
          <img src="/icons/account.png" class="icon__img" alt="" /> Profile
        </a>
      </li>

      <li *ngIf="domainService.isCommunityDomain()" class="nav-item">
        <a class="nav-link">
          <img src="/icons/home.png" class="icon__img" alt="" /> Communities
        </a>

        <ul class="submenu list-unstyled ps-3" *ngIf="userCommunities?.length">
          <li *ngFor="let community of userCommunities"
              [class.active]="('' + community.id) === currentCommunityId">
            <a class="nav-link"
               role="button"
               (click)="onCommunityChange(community)">
              {{ community.community_name }}
              <span *ngIf="isSwitching && ('' + community.id) === currentCommunityId"
                    class="ms-2 spinner-border spinner-border-sm align-middle"></span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Profile (profile domain) -->
      <li routerLinkActive="active" *ngIf="domainService.isProfileDomain()">
        <a [routerLink]="['/profile']">
          <img src="/icons/account.png" class="icon__img" alt="" /> Profile
        </a>
      </li>

      <!-- Logout -->
      <li routerLinkActive="active">
        <a (click)="onLogout()">
          <img src="/icons/logout.png" class="icon__img" alt="" /> Logout
        </a>
      </li>
    </ul>
  </div>
</div>
